module.exports = __webpack_public_path__ + "static/fp-comic-ca3fc33f4a5c1a563873e032ca2cf17c.png";